export default {"src":"/_next/static/media/clock.21687083.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};